import ColorFilter from 'filters/ColorFilter/ColorFilter';
import { FilterType } from 'rangeConfig/@types';

export const colorFilter = {
  component: ColorFilter,
  title: 'storageone.colorFilterLabel',
  id: 'color',
  type: FilterType.FILTER
};
